<template>
<div class="chapter">
<div class="inner_page">
<p class="img_center"><a id="page_14"><img alt="img" src="images/page_014.jpg"/></a></p><a id="page_14">
</a><p class="hrightt"><a id="page_14"></a><a id="page_15"><span class="litbrown">This bib is sweet and bright like its namesake fruit, and it is even worked in “segments.” Decreases are worked at the edges of each segment, bringing each one to a point.</span></a></p><a id="page_15">
<p class="sh1t"><span class="orange">FINISHED MEASUREMENTS</span></p>
<p class="normal"><span class="orange">9½ (11)" diameter at widest point</span></p>
<p class="sh1"><span class="orange">YARN</span></p>
<p class="normal"><span class="orange">Berroco Comfort Chunky (50% super fine nylon / 50% super fine acrylic; 100 grams / 150 yards): 1 skein #5724 Pumpkin</span></p>
<p class="sh1"><span class="orange">NEEDLES</span></p>
<p class="normal"><span class="orange">One pair straight needles size US 10½ (6.5 mm)</span></p>
<p class="normal"><span class="orange">Change needle size if necessary to obtain correct gauge.</span></p>
<p class="sh1"><span class="orange">NOTIONS</span></p>
<p class="normal"><span class="orange">Stitch markers</span></p>
<p class="sh1"><span class="orange">GAUGE</span></p>
<p class="normal"><span class="orange">14 sts and 20 rows = 4" (10 cm) in Stockinette stitch (St st)</span></p>
<p class="sh1t"><span class="litbrown">BIB</span></p>
<p class="normal">Using Long-Tail CO (see Special Techniques, page 156), CO 86 (100) sts.</p>
<p class="normal"><b>Decrease Row 1 (RS):</b> K1, [k2tog, k8 (10) sts, ssk, pm] 7 times, k1—72 (86) sts remain. Knit 5 rows.</p>
<p class="normal"><b>Decrease Row 2 (RS):</b> Change to St st. Decrease 14 sts this row, then every 4 rows 3 (4) times, as follows: K1, [k2tog, knit to 2 sts before marker, ssk, sm] 7 times, k1—16 sts remain. Work even for 3 rows, removing markers.</p>
<p class="normal"><b>Decrease Row 3 (RS):</b> K1, [k2tog] 7 times, k1—9 sts remain. Work even for 1 row.</p>
<p class="normal"><b>Decrease Row 4 (RS):</b> [K3tog] 3 times—3 sts remain. BO all sts.</p>
<p class="sh1"><span class="litbrown">TIE</span></p>
<p class="normal">Using Knitted or Cable CO (see Special Techniques, page 156), CO 34 (40) sts, turn so that CO sts are on right-hand needle. With RS of Bib facing, pick up and knit 1 st at corner of CO edge and right side edge, pass next st (last CO st) over picked-up st, pick up and knit 33 (39) sts along side edge, BO edge, then other side edge, turn—67 (79) sts.</p>
<p class="normal"><b>Next Row:</b> Using Knitted or Cable CO, CO 33 (39) sts, knit to end—100 (118) sts. BO all sts purlwise.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Chapter03.vue?e7cb19dc